<template>
  <div class="footer">
    <div class="kw clearfix">
      <div class="footerLeft">
        <div class="footerLink" style="width: 170px;">
          <div class="f18 fb">关于我们</div>

          <div class="pt25">

            <template v-if="type == 'home'">
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h1')" >公司简介</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h2')" >服务领域</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h3')" >经典案例</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h4')" >资质荣誉</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h5')" >佳世动态</a></div>
              <div class="footerLinkItem"><a href="javascript:;" @click="scrollToSection('h6')" >联系我们</a></div>
            </template>
            <template v-else>
              <div class="footerLinkItem"><router-link to="/asia/index?pageId=h1" >公司简介</router-link></div>
              <div class="footerLinkItem"><router-link to="/asia/index?pageId=h2" >服务领域</router-link></div>
              <div class="footerLinkItem"><router-link to="/asia/index?pageId=h3" >经典案例</router-link></div>
              <div class="footerLinkItem"><router-link to="/asia/index?pageId=h4" >资质荣誉</router-link></div>
              <div class="footerLinkItem"><router-link to="/asia/index?pageId=h5" >佳世动态</router-link></div>
              <div class="footerLinkItem"><router-link to="/asia/index?pageId=h6" >联系我们</router-link></div>
            </template>



          </div>
        </div>

        <div class="footerLink" style="width: 450px;">
          <div class="f18 fb">联系我们</div>

          <div class="pt25">
            <div class="footerLinkItem" v-if="configInfo.tel"><span class="footerLinkIcon"><i class="iconfont icon-dianhua"></i>{{configInfo.tel}}</span></div>
            <div class="footerLinkItem" v-if="configInfo.webSite"><span class="footerLinkIcon"><i class="iconfont icon-wangluo"></i>{{configInfo.webSite}}</span></div>
            <div class="footerLinkItem" v-if="configInfo.email"><span class="footerLinkIcon"><i class="iconfont icon-email"></i>{{configInfo.email}}</span></div>
            <div v-if="configInfo.address" v-html="configInfo.address">
              <!-- <div class="footerLinkItem">
                <div class="footerLinkIcon">
                  <i class="iconfont icon-zuobiao"></i>
                  <div class="fb" style="font-size: 18px; padding-bottom: 8px;">佳世上海</div>
                    上海市普陀区曹杨路450号绿地和创大厦1001室内
                </div>
              </div>


              <div class="footerLinkItem">
                <div class="footerLinkIcon">
                    <div class="fb" style="font-size: 18px; padding-bottom: 8px;">佳世北京</div>
                    北京市朝阳区八里庄西里99号住邦2000商务中心2号楼701室内
                </div>
              </div>


              <div class="footerLinkItem">
                <div class="footerLinkIcon">
                    <div class="fb" style="font-size: 18px; padding-bottom: 8px;">佳世深圳</div>
                    深圳市南山区海德二道正东名苑1栋712室
                </div>
              </div> -->
            </div>



          </div>

        </div>

      </div>
      <div class="footerRight tr">
        <router-link to="/" >
          <img src="@/assets/images/footLogo.jpg" />
        </router-link>

        <footerShaer/>
      </div>
    </div>
  </div>
</template>

<script>
import footerShaer from '@/components/footerShaer.vue'
export default {
  components:{
    footerShaer
  },
  props: {
    configInfo: {},
    type:{
      default:''
    }
  },
  methods:{
    scrollToSection(sectionId){
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }

    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/asia/footer.vue